exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".iframe-container {\n  height: 170px;\n  margin-bottom: 15px;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n", ""]);

